<template>
    <div class="app-container">
        <div class="container">
            <el-row class="saveBtn">
                <el-button type="primary" @click="save" size="mini">保存</el-button>
            </el-row>
        </div>
        <div class="jiBenXinXi">
            <div style="padding-top: 10px;margin-left: 15px">
                <div class="title">基本信息</div>
                <el-form
                        class="formClass"
                        label-width="100px"
                        :model="form"
                        :rules="rules"
                >
                    <el-form-item label="角色名称:" prop="rolename">
                        <el-input v-model="form.rolename"/>
                    </el-form-item>
                    <el-form-item label="角色描述:" prop="decsription">
                        <el-input v-model="form.decsription" type="textarea"/>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="powerList" style="margin-top: 10px;">
            <el-table
                    :data="tableData"
                    stripe
                    border
                    row-key="pid"
                    :default-expand-all="true"
                    :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
            >
                <el-table-column
                        prop="powerName"
                        label="系统菜单权限"
                        width="300px"
                >
                    <template slot-scope="{row}">
                        <el-checkbox
                                v-model="row.check"
                                :label="row.powerName"
                                :true-label="2"
                                :false-label="1"
                                :indeterminate="row.check === 3"
                                @change="changeStatus(row,row.check)"
                        />
                    </template>
                </el-table-column>


                <el-table-column
                        label="功能菜单权限"
                >
                    <template slot-scope="{row}">

                        <el-checkbox
                                v-for="item in row.list"
                                :key="item.pid"
                                v-model="item.check"
                                :label="item.powerName"
                                :true-label="2"
                                :false-label="1"
                                @change="changeStatus(item,item.check)"
                        />
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>

    export default {
        name: 'Currency',
        data() {
            return {
                pid: 0,//角色ID， 如果大于0 表示编辑
                tableData: [],
                pageNum: 1,
                pageSize: 5,
                total: 0,
                form: {
                    rolename: '',
                    decsription: ''
                },
                rules: {
                    rolename: [
                        {required: true, message: '请输入角色名称', trigger: 'blur'}
                    ],
                    decsription: [
                        {required: true, message: '请输入角色描述', trigger: 'blur'}
                    ]
                },
                checkList: [],
                accountList: [],
                selectPidMap: new Map(), // 1 = 未选中，2 = 选中，3 = 半选
            }
        },
        mounted() {
            this.pid = this.$route.query.pid;
            if (this.pid > 0) {
                this.detail()
            } else {
                this.getPowerList();
            }

        },
        methods: {
            // 获取最大权限树
            getPowerList() {
                this.$post(this.$url.用户最大权限树).then(res => {
                    this.initPowerTree(res)
                })
            },


            /**
             * 初始化权限菜单数据
             * @param sourceData 元数据
             * */
            initPowerTree(sourceData) {
                for (const item of sourceData) {
                    let tableItem = {};
                    tableItem.pid = item.pid;
                    tableItem.powerName = item.powerName;
                    tableItem.parentId = item.parentId;
                    tableItem.check = 1;
                    tableItem.indeterminate = false;
                    tableItem.children = [];

                    if (item.children.length < 1) {
                        this.tableData.push(tableItem);
                        if(this.selectPidMap.get(tableItem.pid) !== 2){
                            this.selectPidMap.set(tableItem.pid, 1);
                        }
                        continue;
                    }

                    //第二级
                    for (const itemChildren of item.children) {
                        let secondLevel = {};
                        secondLevel.pid = itemChildren.pid;
                        secondLevel.powerName = itemChildren.powerName;
                        secondLevel.parentId = itemChildren.parentId;
                        secondLevel.check = 1;
                        secondLevel.indeterminate = false;
                        secondLevel.list = [];
                        if (itemChildren.children.length < 1) {
                            //放二级到一级中
                            tableItem.children.push(secondLevel);
                            continue;
                        }

                        //第三级
                        for (const tertiaryItem of itemChildren.children) {
                            let tertiary = {};
                            tertiary.pid = tertiaryItem.pid;
                            tertiary.powerName = tertiaryItem.powerName;
                            tertiary.parentId = tertiaryItem.parentId;
                            tertiary.check = 1;
                            tertiary.indeterminate = false;
                            //把三级放到二级中
                            secondLevel.list.push(tertiary);
                        }
                        //放二级到一级中
                        tableItem.children.push(secondLevel);

                    }

                    this.tableData.push(tableItem);
                }


            },
            /**
             * 变更选中状态
             *  @param row 本级数据
             * */
            changeStatus(row, check) {
                //需要变更的状态 1 = 未选中，2 = 选中，3 = 半选
                this.setSelectPidMap(row.pid, check);

                //判断是否有上级
                if (row.parentId > 0) {
                    this.changeSuperiorStatus(row.parentId, check);
                }

                //判断是否有下级
                if (row.children && row.children.length > 0) {
                    this.changeSubordinate(row.children, check);
                }
                if (row.list && row.list.length > 0) {
                    this.changeSubordinate(row.list, check);
                }

                //变更整棵树的中节点是否选中
                this.updateTableData();
                this.$forceUpdate();
            },

            updateTableData() {
                for (const item of this.tableData) {
                    item.check = this.selectPidMap.get(item.pid);
                    this.updateIndeterminate(item);
                    if (item.children.length < 1) {
                        continue;
                    }

                    //第二级
                    for (const itemChildren of item.children) {
                        itemChildren.check = this.selectPidMap.get(itemChildren.pid);
                        this.updateIndeterminate(itemChildren);
                        if (itemChildren.list.length < 1) {
                            continue;
                        }

                        //第三级
                        for (const tertiaryItem of itemChildren.list) {
                            tertiaryItem.check = this.selectPidMap.get(tertiaryItem.pid);
                            this.updateIndeterminate(tertiaryItem);
                        }

                    }
                }
            },
            /**
             * 修改半选属性
             * check 1 = 未选中，2 = 选中，3 = 半选
             * */
            updateIndeterminate(item) {
                if (item.check === 3) {
                    item.indeterminate = true;
                } else {
                    item.indeterminate = false;
                }
            },

            /**
             *  设置pid 到 selectPidMap 中
             *  check 1 = 未选中，2 = 选中，3 = 半选
             * */
            setSelectPidMap(pid, check) {
                if (check) {
                    this.selectPidMap.set(pid, check);
                } else {
                    this.selectPidMap.set(pid, 1);
                }
            },

            /**
             * 变更上级
             * @param pid 上级ID
             * @param status 需要变更的状态 1 = 未选中，2 = 选中，3 = 半选
             *
             * */
            changeSuperiorStatus(pid, status) {
                let superiorItem = this.findNodeByPid(pid, this.tableData);
                if (!superiorItem) {
                    return;
                }
                if (status === 2) {
                    //如果是选中，获取我下级是否全部选中
                    let checkAll = false;
                    if (superiorItem.children) {
                        checkAll = this.selectAll(superiorItem.children);
                    }
                    if (superiorItem.list) {
                        checkAll = this.selectAll(superiorItem.list);
                    }
                    if (checkAll) {
                        //如果全部选中
                        this.setSelectPidMap(superiorItem.pid, 2);
                    } else {
                        //如果存在为选中的，则记录半选
                        this.setSelectPidMap(superiorItem.pid, 3);
                    }
                } else if (status === 1) {
                    //如果不是选中状态，判断子级是否有选中的，如果有，则设置为半选，如果没有则设置为未选中
                    this.setSelectPidMap(superiorItem.pid, status);
                    let checkOne = false;
                    if (superiorItem.children) {
                        checkOne = this.selectOne(superiorItem.children);
                    }
                    if (superiorItem.list) {
                        checkOne = this.selectOne(superiorItem.list);
                    }

                    if (checkOne) {
                        //还存在有选中的，记录半选
                        //status  = 3; // 此处是当修改为3以后，则需要同步让上级的上级知道，上级是修改为 3
                        this.setSelectPidMap(superiorItem.pid, 3);
                    } else {
                        //不存在选中的，则记录未选中
                        this.setSelectPidMap(superiorItem.pid, 1);
                    }

                } else {
                    //如果是半选，则直接记录对应状态即可
                    this.setSelectPidMap(superiorItem.pid, status);
                }

                //递归更新父级
                if (superiorItem.parentId > 0) {
                   this.changeSuperiorStatus(superiorItem.parentId, status);
                }
            },

            /**
             * 变更下级
             * @param list 下级数组集合
             * @param status 需要变更的状态 1 = 未选中，2 = 选中，3 = 半选
             * */
            changeSubordinate(list, status) {
                for (const item of list) {
                    this.setSelectPidMap(item.pid, status);
                    //判断是否有下级
                    if (item.children && item.children.length > 0) {
                        this.changeSubordinate(item.children, status);
                    }
                    if (item.list && item.list.length > 0) {
                        this.changeSubordinate(item.list, status);
                    }
                }
            },


            /**
             * 在tableData中根据 pid找到对应节点，并返回
             * @param pid 节点ID
             * @param tableData 查询的数组
             * */
            findNodeByPid(pid, tableData) {
                if (pid === 0) {
                    return
                }
                if (tableData.length < 1) {
                    return;
                }
                for (const item of tableData) {
                    if (item.pid === pid) {
                        return item;
                    }
                    if (item.children) {
                        let node = this.findNodeByPid(pid, item.children);
                        if (node) {
                            return node;
                        }
                    }
                    if (item.list) {
                        let node = this.findNodeByPid(pid, item.list);
                        if (node) {
                            return node;
                        }
                    }
                }

            },
            /**
             * 获取数组中的节点是否全部选中，全部选中返回true，否则返回false
             * @param list
             * */
            selectAll(list) {
                let len = list.length;
                let num = 0;
                for (const item of list) {
                    if (this.selectPidMap.get(item.pid) === 2) {
                        num++;
                    }
                }
                return num === len;
            },
            /**
             * 判断list中是否存在一个选中的
             * 存在则返回 true ， 不存在则返回false
             * */
            selectOne(list) {
                let num = 0;
                for (const item of list) {
                    //全选或者半选都算选中
                    let check = this.selectPidMap.get(item.pid);
                    if (check === 2 || check === 3) {
                        num++;
                    }
                }

                return num > 0;
            },


            /**
             * 查询详情
             */
            detail() {
                this.$post(this.$url.角色详情, {pid: this.pid}).then(res => {
                    const {powerListVOList, roleDescription, roleName, rolePowerPidList} = res
                    this.form.rolename = roleName
                    this.form.decsription = roleDescription
                    for (const powerPid of rolePowerPidList) {
                        this.selectPidMap.set(powerPid, 2);
                    }
                    this.initPowerTree(powerListVOList)
                    this.supplementMap();
                })
            },

            /**
             * 矫正选中状态，
             * */
            supplementMap() {

                for (const one of this.tableData) {
                    if (one.children.length === 0) {
                        let status = this.selectPidMap.get(one.pid);
                        if (status === 2) {
                            this.changeStatus(one, status);
                        }
                        continue;
                    }
                    //第二级
                    for (const two of one.children) {
                        if (two.list.length === 0) {
                            let status = this.selectPidMap.get(two.pid);
                            if (status === 2) {
                                this.changeStatus(two, status);
                            }
                            continue;
                        }
                        //第三级
                        for (const child of two.list) {
                            let status = this.selectPidMap.get(child.pid);
                            if (status === 2) {
                                this.changeStatus(child, status);
                            }
                        }
                    }

                }
            },

            /**
             * 保存
             */
            save() {
                const ids = this.getChecked()
                const data = {
                    powerPidList: ids,
                    roleDescription: this.form.decsription,
                    roleName: this.form.rolename,
                }
                if (this.pid > 0) { // 编辑
                    data.pid = this.pid
                    this.$post(this.$url.角色修改, data).then(res => {
                        this.$message.success('角色编辑成功')
                        this.$router.push({name: "PlatformuserRoleList"})
                    })
                } else { // 新增
                    this.$post(this.$url.角色添加, data).then(res => {
                        this.$message.success('角色新增成功')
                        this.$router.push({name: "PlatformuserRoleList"});
                    })
                }
            },


            // 获取所有选择的权限
            getChecked() {
                const ids = []
                for (const selectPidMapElement of this.selectPidMap) {
                    let pid = selectPidMapElement[0];
                    let value = selectPidMapElement[1];
                    if (value === 2 || value === 3) {
                        ids.push(pid);
                    }
                }
                return ids
            }
        }
    }
</script>

<style scoped lang="less">
    .app-container {
        height: 100%;
        width: 100%;
        margin: 0 auto;
    }

    .container {
        height: 42px;
        width: 100%;
        background-color: #FFFFFF;
        line-height: 42px;

        .saveBtn {
            float: left;
            margin-left: 15px;
        }
    }

    .jiBenXinXi {
        background-color: #FFFFFF;
        height: 176px;
        margin-top: 12px;

        .title {
            margin-bottom: 16px;
        }

        .formClass {
            width: 500px;
        }
    }

    .powerList {
        background-color: #FFFFFF;
        height: 600px;
        overflow: auto
    }

</style>
